import script from "./WithdrawalTokenSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawalTokenSelect.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawalTokenSelect.vue?vue&type=style&index=0&id=49c98156&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c98156"]])

export default __exports__